import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";
import "@firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDTOk2pWHYuMVHMCPIeA2INd3zhkBGksAg",
  authDomain: "pronaid.firebaseapp.com",
  databaseURL: "https://pronaid.firebaseio.com",
  projectId: "pronaid",
  storageBucket: "pronaid.appspot.com",
  messagingSenderId: "206217735193",
  appId: "1:206217735193:web:102207560a5cfdc8948e88",
  measurementId: "G-64WT27Y5TB"
};

firebase.initializeApp(firebaseConfig);
// Initialize Cloud Functions through Firebase

const db = firebase.firestore();
const storage = firebase.storage();
export { db, storage };
